module.exports = __webpack_public_path__ + "static/img/1.4828c89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/1.png
// module id = 9xfE
// module chunks = 0